import React, { useContext, useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import "./Admins.css";

import { AppContext } from "../../Context/AppContext";
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate } from "react-router-dom";

import * as Fa from "react-icons/fa";
import * as Ri from "react-icons/ri";
import toast, { Toaster } from "react-hot-toast";
import { message } from "antd";
import { PulseLoader } from "react-spinners";

function Profile() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    updateAdminDetails,
    fetchAdmins,
    adminsLoading,
    adminDetails,
    fetchSingle,
    setAdminDetails,
    resetReq,
    authLoading,
  } = useContext(AppContext);
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    role: "",
  });
  const [isEdit, setIsEdit] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    id: 0,
    name: "",
    email: "",
    phoneNumber: "",
    role: "",
  });
  const [error, setError] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isEdit = searchParams.get("edit") === "true";
    if (isEdit === true) {
      setIsEdit(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!adminDetails) return;

    console.log(adminDetails, "adminDetails");

    setProfile({
      name: adminDetails?.name ?? "",
      email: adminDetails?.email,
      phoneNumber: adminDetails?.phoneNumber,
      role: adminDetails?.role,
    });
    setProfileDetails({
      id: adminDetails?._id,
      name: adminDetails?.name ?? "",
      email: adminDetails?.email,
      phoneNumber: adminDetails?.phoneNumber,
      role: adminDetails?.role,
    });
  }, [adminDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phoneNumber" && !/^\d*$/.test(value)) return;
    setProfileDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEmptyFields = () => {
    if (
      profileDetails.name.length === 0 ||
      !profileDetails.email ||
      profileDetails.email.trim() === "" ||
      profileDetails.email.length === 0
    ) {
      setError(true);
      return true;
    }
    setError(false);
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!profileDetails.id || profileDetails.id == 0) {
      toast.error("Admin ID is required!");
      return;
    }

    let payload = {
      id: profileDetails.id,
    };

    const isNotValid = handleEmptyFields();

    if (isNotValid) return;

    for (const key in profileDetails) {
      if (key !== "id" && profileDetails[key] !== profile[key]) {
        payload[key] = profileDetails[key];
      }
    }

    if (Object.keys(payload).length === 1) return;

    await updateAdminDetails(payload, {
      onSuccess: async (res) => {
        const adminId = res?.data?._id;
        toast.success("Admin Details updated");
        await fetchAdmins();
        await fetchSingle(adminId, {
          onSuccess: (res) => {
            const data = res?.data;
            setAdminDetails(data);
          },
          onFailed: (err) => {
            console.log("Error on fetching admin data", err);
          },
        });
        navigate(location.pathname);
        setIsEdit(false);
      },
      onFailed: (error) => {
        const errMsg = error?.data ?? "Profile update failed!";
        toast.error(errMsg);
        console.error("Error updating admin details", error);
      },
    });
  };

  const handleForgotPass = async () => {
    if (!adminDetails?.email) {
      toast.error("Email is unavailable!");
      return;
    }
    await resetReq(
      { email: adminDetails?.email },
      {
        onSuccess: (res) => {
          toast.success("Otp sent to your email address successfully!");
          navigate("/verify-otp");
          sessionStorage.setItem("email", res.data.email);
          sessionStorage.setItem("id", res.data._id);
        },
        onFailed: (err) => {
          const errMsg = err.message ?? "Something went wrong!";
          toast.error(errMsg);
        },
      }
    );
  };

  return (
    <>
      <Toaster />
      <div className="container-fluid background">
        <Header />
        <div className="mains">
          <div className="profile_container">
            <div className="profile_card text-center">
              {isEdit ? (
                <div className="text-start">
                  <button
                    type="button"
                    className="btn btn-light rounded-circle"
                    onClick={() => {
                      setIsEdit(false);
                      navigate(location.pathname, { replace: false });
                    }}
                  >
                    <Ri.RiCloseLine />
                  </button>
                  <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
                    <div className="form-group mt-3">
                      <label htmlFor="" className="form-label">
                        Fullname
                      </label>
                      <input
                        type="text"
                        name="name"
                        id=""
                        className="form-control"
                        value={profileDetails?.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group mt-3">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="johndoe@example.com"
                        value={profileDetails?.email}
                        onChange={handleChange}
                      />
                      {error &&
                        profileDetails &&
                        profileDetails?.email.length === 0 && (
                          <span className="text-danger">Email is required</span>
                        )}
                    </div>

                    <div className="form-group mt-3">
                      <label htmlFor="phone" className="form-label">
                        Phone
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phoneNumber"
                        className="form-control"
                        value={profileDetails?.phoneNumber}
                        onChange={handleChange}
                        maxLength={12}
                      />
                    </div>
                    <br />
                    <button
                      type="submit"
                      className="edit_btn mx-auto d-block"
                      disabled={adminsLoading}
                    >
                      {adminsLoading ? (
                        <PulseLoader color="#fff" size={10} />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </form>
                </div>
              ) : (
                <>
                  {" "}
                  <div className="profile_avatar">
                    <Fa.FaUserCircle />
                  </div>
                  <div className="profile_info">
                    <h2>{profile?.name ?? "Admin"}</h2>
                    <p className="email">{profile?.email ?? "N/A"}</p>
                    <div className="profile_details">
                      <div>
                        <label>Phone</label>
                        <p>{profile?.phoneNumber ?? "N/A"}</p>
                      </div>
                      <div>
                        <label>Role</label>
                        <p>{profile?.role}</p>
                      </div>
                    </div>
                    <button
                      className="edit_btn"
                      onClick={() => {
                        setIsEdit(true);
                        navigate(`${location.pathname}?edit=true`, {
                          replace: false,
                        });
                      }}
                    >
                      Edit Profile
                    </button>
                  </div>
                </>
              )}
              <br />
              <p className="m-0">
                {!authLoading && (
                  <>
                    <strong> Change your current password?</strong>{" "}
                    <button
                      type="button"
                      className="link_btn"
                      onClick={handleForgotPass}
                    >
                      Click here
                    </button>
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
